import React from "react";
import { Col, Container, Row } from "reactstrap";

import img01 from "../assets/images/feature/img-01.png";
import img02 from "../assets/images/feature/img-02.png";
import img03 from "../assets/images/feature/img-03.png";
import img04 from "../assets/images/feature/img-04.png";
import img05 from "../assets/images/feature/img-05.png";
import img06 from "../assets/images/feature/img-06.png";
import img07 from "../assets/images/feature/img-07.png";
import img08 from "../assets/images/feature/img-08.png";

const ServicesCard = (props) => {
  return (
    <>
      <Col lg={4} md={6}>
        <div
          className={
            props.isShadow
              ? "service-box text-center mt-4 box-shadow"
              : "service-box text-center mt-4"
          }
        >
          <img src={props.imgsrc} alt="" className="img-fluid" />
          <h5 className="fs-18 mt-4">{props.title}</h5>
          <div className="lighlight-border mt-3"></div>
          <p className="text-muted mt-3">{props.caption}</p>
        </div>
      </Col>
      {/* <!--end col--> */}
    </>
  );
}

// Services data

const ServicesData = [
  {
    imgsrc: img01,
    title: "Modern Data Platforms",
    caption:
      "We design and build modern data platforms for SAP customers using SAP Datasphere, SAP Business Data Cloud (BDC), and leading cloud technologies including AWS, Azure, Snowflake, and Databricks. Our solutions integrate SAP and non SAP data into scalable, governed platforms supporting analytics and AI.",
  },
  {
    imgsrc: img02,
    title: "Analytics",
    caption:
      "We deliver analytics and insight solutions using SAP Analytics Cloud and best of breed BI tools, enabling business users to access trusted, business ready insights. Our focus is on semantic modelling, performance, and usability, ensuring analytics solutions support informed decision making across SAP and cloud data platforms.",
    isShadow: true,
  },
  {
    imgsrc: img05,
    title: "Custom Applications, Service Layer & Cloud Solutions",
    caption:
      "We design and build custom SAP BTP applications using CAP, SAPUI5, node.js, React and cloud native services. Our solutions include secure service layers, business applications, and SAP extensions that integrate seamlessly with core systems while supporting scalability, maintainability, and future platform evolution",
    isShadow: true,
  },
  {
    imgsrc: img03,
    title: "Integration & Event Driven Architecture",
    caption:
      "We design secure, scalable integration architectures on SAP BTP using SAP Integration Suite, APIs, and event driven patterns. Our solutions connect SAP and non SAP systems across hybrid and multi cloud landscapes, enabling real time data exchange, extensibility, and resilient system to system communication.",
  },
  {
    imgsrc: img04,
    title: "Agentic and Generative AI",
    caption:
      "We design and build AI Agents and Gen AI solutions that leverage data from SAP and cloud platforms to enhance analytics and operational processes. Our Agents and models are designed for real world deployment, integrating into SAP BTP architectures to deliver actionable insights and intelligent, data driven capabilities.",
    isShadow: true,
  },
  
  {
    imgsrc: img06,
    title: "Strategy, Architecture & Governance",
    caption:
      "We provide strategy, architecture, and governance services to support successful SAP BTP and data platform adoption. Our approach covers platform design, operating models, security, and standards, ensuring solutions are scalable, maintainable, and aligned with business objectives and enterprise architecture principles.",
    isShadow: true,
  },
  {
    imgsrc: img07,
    title: "S/4HANA & ERP Transformation",
    caption:
      "We guide organisations through S/4HANA migrations and broader ERP transformation initiatives. From strategy and roadmap design through implementation governance, data readiness, and post go live optimisation, we provide independent expertise to ensure programs deliver measurable business outcomes, not just technical upgrades.",
    isShadow: true,
  },
  {
    imgsrc: img08,
    title: "ERP Advisory & Program Assurance",
    caption:
      "We provide independent ERP advisory services, including program governance, portfolio management, internal QA, and functional leadership. Acting as a bridge between business stakeholders and system integrators, we protect delivery quality, manage risk, and ensure enterprise transformation programs remain aligned to strategic objectives.",
    isShadow: true,
  },
];

const Services = () => {
  return (
    <>
      <section className="section" id="services">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}> 
              <div className="header-title text-center">
                {/* <p className="text-uppercase text-muted mb-2">
                  Services We Provide
                </p> */}
                <h3> Services We Provide</h3>
                <div className="title-border mt-3"></div>
                <p className="text-muted mt-3">
                At Citra, we help SAP customers design, build, and operate solutions on SAP Business Technology Platform and modern data platforms. Our services span data and analytics, integration, custom application development and Agentic AI, enabling organisations to integrate, extend, and modernise their SAP landscapes with confidence.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Services Component Start */}

            {ServicesData.map((value, idx) => (
              <ServicesCard
                key={idx}
                imgsrc={value.imgsrc}
                title={value.title}
                caption={value.caption}
                isShadow={value.isShadow}
              />
            ))}

            {/* Services Component End */}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Services;
